var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.117 11.6913L0 1.5L15.0217 6.376L10.117 11.6913Z",
    fill: "#171717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7102 12.2796L18.8399 22.4113L15.6075 6.95591L10.7102 12.2796Z",
    fill: "#171717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8487 22.5L6.36292 17.4384L13.7884 17.4409L17.8487 22.5Z",
    fill: "#171717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4887 1.60916L15.6935 5.72742L12.0351 4.5378L19.4887 1.60916Z",
    fill: "#171717"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1456 4.17867L20.2957 1.96237L24 4.28533L18.1456 4.17867Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigma);
export default __webpack_public_path__ + "static/media/sigma.7dee37f549a680780995be6bdc99c027.svg";
export { ForwardRef as ReactComponent };